/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const AddPanelSpline64Icon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 64, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="AddPanelSpline64Icon"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <circle opacity="0.1" cx="32" cy="32" r="14" fill="white" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.0028 31.7172C18.0026 31.7171 18.0029 31.7173 18.0028 31.7172C18.0009 31.8114 17.9995 31.9054 17.9995 32C17.9995 32.3426 18.0118 32.6823 18.036 33.0187C18.0359 33.0186 18.0362 33.0188 18.036 33.0187C18.5539 40.2184 24.5166 45.9106 31.8273 45.999C31.8273 45.9989 31.8273 45.999 31.8273 45.999C31.8846 45.9996 31.942 46 31.9995 46C32.1305 46 32.2611 45.9982 32.3912 45.9946C32.6213 45.9883 32.85 45.9765 33.0771 45.9592C40.3058 45.4092 46 39.3696 46 32C46 24.268 39.7319 18 32 18C24.3625 18 18.1534 24.1158 18.0028 31.7172ZM30.9786 44.9605C29.3178 42.7436 28.082 39.9204 27.457 36.7483C24.302 36.2934 21.4445 35.2429 19.1189 33.766C19.9356 39.779 24.8636 44.4852 30.9786 44.9605ZM19.009 32.4898C21.2342 34.0571 24.0788 35.2022 27.2763 35.7096C27.0952 34.5125 27 33.2716 27 32C27 26.9101 28.5258 22.3135 30.9786 19.0395C24.2763 19.5604 19 25.164 19 32C19 32.164 19.003 32.3272 19.009 32.4898ZM32.2826 44.997C32.0544 44.7244 31.8328 44.4394 31.6182 44.1424C30.1887 42.1631 29.0981 39.676 28.5038 36.876C29.3197 36.9578 30.153 37 31 37C36.6538 37 41.6989 35.1174 44.9988 32.1727C44.9076 39.1787 39.2744 44.8479 32.2826 44.997ZM44.9491 30.8423C44.4103 31.3872 43.8063 31.9022 43.1424 32.3817C40.0735 34.5982 35.7837 36 31 36C30.0837 36 29.1856 35.9486 28.3108 35.8499C28.1077 34.6149 28 33.3264 28 32C28 27.2163 29.4018 22.9265 31.6182 19.8576C31.8328 19.5606 32.0544 19.2756 32.2826 19.003C38.9436 19.1451 44.3715 24.2972 44.9491 30.8423Z"
            fill="currentColor"
          />
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

AddPanelSpline64Icon.tags = ['animation'];

AddPanelSpline64Icon.category = '64x64 (Add panel)';

AddPanelSpline64Icon.iconSize = 64;
